import { ChangeDetectorRef, Component, NgZone, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ESignService } from 'src/app/services/e-sign.service';


export function emailOrMobileValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null; 
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobileRegex = /^[6-9]\d{9}$/; 
    if (emailRegex.test(value) || mobileRegex.test(value)) return null; 
    return { invalidContactFormat: true }; 
  };
}

@Component({
  selector: 'app-share-sign-link',
  templateUrl: './share-sign-link.component.html',
  styleUrls: ['./share-sign-link.component.scss'],
  standalone: false
})
export class ShareSignLinkComponent implements OnInit, OnDestroy {
  authForm!: FormGroup;
  isOtpSent: boolean = false;
  apiErrorMessage: string = '';
  timeLeft: number = 30;
  interval: any;

  otpConfig = {
    length: 6,
    allowNumbersOnly: true,
    inputStyles: {
      width: '45px',
      height: '45px',
      margin: '0 5px',
      'border-radius': '4px',
      border: '1px solid #d1d5db',
      'font-size': '1.2rem',
      'text-align': 'center'
    }
  };

  constructor(
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private esignService: ESignService,
    private router: Router,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.spinner.hide();

    this.authForm = this.fb.group({
      contactInfo: ['', [Validators.required, emailOrMobileValidator()]],
      otp: [''] 
    });
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  get contactControl() { return this.authForm.get('contactInfo'); }
  get otpControl() { return this.authForm.get('otp'); }

  
  onOtpChange(otpString: string) {
    this.otpControl?.setValue(otpString);
  }


  startTimer() {
    this.timeLeft = 30;
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.ngZone.runOutsideAngular(() => {
      this.interval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.interval);
        }
        this.cdr.detectChanges();
      }, 1000);
    });
  }

  sendOtp(isResend: boolean = false): void {
    if (this.contactControl?.valid) {
      this.spinner.show();
      this.apiErrorMessage = ''; 
      
      const inputValue = this.contactControl.value;
      const isEmail = inputValue.includes('@');
      const payload = isEmail ? { email: inputValue } : { mobile: inputValue };

      this.esignService.requestShareSignOtp(payload).subscribe({
        next: (response) => {
          this.spinner.hide();
          this.isOtpSent = true;
          this.startTimer();
          
          if (!isResend) {
            this.otpControl?.setValidators([Validators.required, Validators.pattern('^[0-9]{6}$')]);
            this.otpControl?.updateValueAndValidity();
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.apiErrorMessage = 'No eSign links found associated with this mobile number or email ID. Please try again.';
          console.error('API Error:', error);
        }
      });
    } else {
      this.contactControl?.markAsTouched();
    }
  }

  verifyOtp(): void {
    
    if (this.authForm.valid) {
      this.spinner.show();
      this.apiErrorMessage = ''; 
      
      const contactValue = this.contactControl?.value;
      const enteredOtp = this.otpControl?.value;
      const isEmail = contactValue.includes('@');
      const payload: any = { otp: enteredOtp };
      if (isEmail) payload.email = contactValue;
      else payload.mobile = contactValue;

      this.esignService.verifyShareSignOtp(payload).subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.status === 200) {
            this.esignService.isShareSignVerified = true;
            this.esignService.verifiedContact = contactValue;
            this.esignService.isVerifiedEmail = isEmail;
            this.router.navigate(['/public-sign-link/share-sign-link-details']);
          } else {
            this.apiErrorMessage = response?.message || 'Verification failed. Please try again.';
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err.error && err.error.message) {
            this.apiErrorMessage = err.error.message; 
          } else {
            this.apiErrorMessage = 'Invalid or expired OTP. Please try again.';
          }
        }
      });
    } else {
      this.otpControl?.markAsTouched();
    }
  }
}